import {useEffect,useState, useRef} from "react";
import "./css/SigningFlow.css";
import { STEPS } from "../constants/steps";
import React from "react";

export default function OtpScreen({
    flowData,
    updateFlowData,
    flowContext,
    updateFlowContext,
    next,
    back,
    loading,
    setLoading,
    error,
    setError,
}) {  
   
    const [otp, setOtp] = useState(["", "", "", "", "", ""]);
    const inputRefs = useRef([]);

    const otpComplete = otp.every(d=>d!=="");

    const [seconds,setSeconds]=useState(31); //Countdown timer

    useEffect(()=>{
        if(seconds===0)
            return;
        const id=setInterval(()=>{
            setSeconds(s=>s-1);
        },1000);
        return ()=>clearInterval(id);
    },[seconds]);

    const handleOtpChange = (index,value)=>{

        if (loading) return;
        setError(""); //clear the error whenever the user starts typing again

        if (!/^\d?$/.test(value))
            return;
        const next=[...otp];
        next[index]=value;
        setOtp(next);
        if(value && index<5){
            inputRefs.current[index+1]?.focus();
        }
    };

    const handleKeyDown=(index,e)=>{
        if (loading) return;
        if(
            e.key==="Backspace" &&
            otp[index]==="" &&
            index>0
        ){
            inputRefs.current[index-1]?.focus();
        }
    };

    const handlePaste=(e)=>{
        e.preventDefault();
        if (loading) return;

        const pasted=e.clipboardData
            .getData("text")
            .replace(/\D/g,"")
            .slice(0,6);

        if(!pasted)
            return;

        const next=[...otp];

        pasted.split("").forEach((d,i)=>{
            next[i]=d;
        });

        setOtp(next);

        inputRefs.current[
            Math.min(pasted.length,5)
        ]?.focus();
    };

    const continueToNext = () => {
        //calling updateFlowData is asynchronous, and was sending request without actual otp. Hence used override data in next
        if (loading) return;
        setError("");
        next({
            action: "verify_otp",
            otp: otp.join("")
        });
    };

    const handleResend = () => {
        if (loading) return;
        setError("");        
        next({
            action: "resend_otp"
        });
        setOtp(["","","","","",""]);
        setSeconds(30);
        inputRefs.current[0]?.focus();

    };

    const handleChangeNumber = () => {
        setError("");
        next({
            action: "change_phone"
        });
    };

    return (
        <div className={`page ${loading ? "page-loading" : ""}`}>

            {loading && (
                <div className="loading-overlay">
                    Loading...
                </div>
            )}

            {error && (
                <div className="text-red-600 mt-2">
                    {error}
                </div>
            )}
            
            <div className="page-header">

                <h2 className="business-name">
                    {flowContext.selectedService?.name
                        ? `${flowContext.selectedService.name} at ${flowContext.business?.businessName}`
                        : flowContext.business?.businessName}
                </h2>

            </div>

            <div className="page-content otp-page">

                <h3 className="otp-title">
                    Verify your number
                </h3>

                <p className="otp-subtitle">
                    Enter the 6-digit code sent to
                    <br />
                    {flowContext.customerPhone?.phone ?? flowData.phone}
                </p>

                <p>                    
                    Tmp display of OTP is: {flowData.generatedOtp}                     
                </p>

                <div className="otp-boxes">

                    {otp.map((digit, index) => (

                        <input
                            key={index}
                            ref={el => inputRefs.current[index] = el}
                            className="otp-box"
                            type="text"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            autoComplete={index === 0 ? "one-time-code" : "off"}
                            value={digit}
                            maxLength={1}
                            onPaste={index === 0 ? handlePaste : undefined}
                            onKeyDown={(e) => handleKeyDown(index, e)}
                            onChange={(e) =>
                                handleOtpChange(index, e.target.value)
                            }
                        />

                    ))}

                </div>

               <button
                    className="otp-link"
                    disabled={loading || seconds > 0}
                    onClick={handleResend}
                >
                    <span>↻</span>
                    <span>
                        {seconds > 0
                            ? `Resend code in ${seconds}s`
                            : "Resend code"}
                    </span>
                    <span className="otp-link-arrow">
                        ›
                    </span>
                </button>

                <button 
                    className="otp-link"
                    disabled={loading}
                    onClick={handleChangeNumber}
                >

                    <span>📞</span>

                    <span>
                        Change number
                    </span>

                    <span className="otp-link-arrow">
                        ›
                    </span>

                </button>

            </div>

            <div className="page-footer">
               

                <button
                    className="primary-button"
                    disabled={loading || !otpComplete}
                    onClick={continueToNext}
                >
                    Verify
                </button>

                <div className="powered-by">
                    Powered by <strong>DidYouSign</strong>
                </div>

            </div>

        </div>
    );
}